import constants from "../constants";

const { UPDATE_PROJECTS, REMOVE_PROJECTS, SEND_METRICS_LIMITS_BY_PROJECT } = constants;

export const updateProjects = (data) => ({
  type: UPDATE_PROJECTS,
  data,
});

export const removeProjects = (data) => ({
  type: REMOVE_PROJECTS,
  data,
});

export const sendMetricsLimits = (data) => ({
  type: SEND_METRICS_LIMITS_BY_PROJECT,
  data,
});
